var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServices1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    className: "snipcss0-1-1-2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    className: "snipcss0-2-2-3"
  }, "\t.st0{fill:#73BE2F;}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "snipcss0-2-2-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.4,13.1c-0.9-0.9-2-1.3-3.3-1.3c-0.9,0-1.8,0.3-2.5,0.7l-2.9-2.8c0,0,0,0,0,0L3.1,1.3c-0.4-0.4-1-0.4-1.4,0  C1.5,1.5,1.4,1.8,1.4,2c0,0.3,0.1,0.5,0.3,0.7l7.8,7.6l-2.2,2.1c-0.7-0.5-1.6-0.7-2.5-0.7c-1.2,0-2.4,0.5-3.3,1.3  c-0.9,0.9-1.4,2-1.4,3.2s0.5,2.4,1.4,3.2c0.9,0.9,2,1.3,3.3,1.3s2.4-0.5,3.3-1.3c0.9-0.9,1.4-2,1.4-3.2c0-0.9-0.3-1.7-0.7-2.5  l2.2-2.1l2.2,2.1c-0.5,0.7-0.7,1.6-0.7,2.5c0,1.2,0.5,2.4,1.4,3.2c0.9,0.9,2,1.3,3.3,1.3c1.2,0,2.4-0.5,3.3-1.3  c0.9-0.9,1.4-2,1.4-3.2C21.8,15.1,21.3,14,20.4,13.1z M6.8,18.2c-1,1-2.8,1-3.8,0c-0.5-0.5-0.8-1.1-0.8-1.8S2.5,15,3,14.6  c0.5-0.5,1.2-0.8,1.9-0.8s1.4,0.3,1.9,0.8c0,0,0,0,0,0c0.5,0.5,0.8,1.1,0.8,1.8C7.6,17.1,7.3,17.7,6.8,18.2z M19,18.2  c-1,1-2.8,1-3.8,0c-0.5-0.5-0.8-1.1-0.8-1.8c0-0.7,0.3-1.3,0.8-1.8c0,0,0,0,0,0c1-1,2.8-1,3.8,0c0.5,0.5,0.8,1.1,0.8,1.8  C19.8,17.1,19.5,17.7,19,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.6,8.9c0.3,0,0.5-0.1,0.7-0.3l6-5.8c0.2-0.2,0.3-0.5,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7c-0.4-0.4-1-0.4-1.4,0  l-6,5.8c-0.2,0.2-0.3,0.5-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7C13.1,8.8,13.3,8.9,13.6,8.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices1);
export default __webpack_public_path__ + "static/media/services1.f27e5853231a1e4469d12964c7d1620b.svg";
export { ForwardRef as ReactComponent };